import { useState } from "react";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const pathUrl =
    process.env.REACT_APP_BACKEND_URL || "http://localhost:8080/api";

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [e.target.name]: e.target.value });
    console.log(
      `Username: ${formData.username}, Password: ${formData.password}`
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Log the entered username and password before send request
    console.log(
      `Username: ${formData.username}, Password: ${formData.password}`
    );

    axios
      .post(pathUrl + "/auth/login", formData)
      .then((response) => {
        login(response.data); // Call login function from context
        console.log(response.data);
        console.log(response.data.role);
        localStorage.setItem("token", response.data.jwt);

        if (response.data.role === "ADMIN") {
          console.log("Role is ADMIN");
          navigate("/admin");
        } else {
          console.log("Role is USER");
          navigate("/ai");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <div className="container mt-5">
      <div className="card" style={{ padding: "20px" }}>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="username"
            id="username"
            placeholder="Enter your username"
            className="form-control mb-3"
            value={formData.userName}
            onChange={handleInputChange}
          />

          <input
            type="password"
            name="password"
            id="password"
            placeholder="Enter your password"
            className="form-control mb-3"
            value={formData.userPassword}
            onChange={handleInputChange}
          />

          <input
            type="submit"
            value="Login"
            className="btn btn-outline-primary form-control rounded-0"
            style={{
              backgroundColor: '#010000',
              borderColor: '#010000',
              color: 'white'
            }}
          />
        </form>
      </div>
    </div>
  );
};

export default Login;
